module.exports = __webpack_public_path__ + "img/pin.0e3d3072.svg";